import style from "./VacancyCardCandidates.module.scss";
import {
  SkeletonTable,
  CandidateBadge,
  NoData,
  PdfViewer,
  RightSidebar,
} from "@/components";
import FilterBlock from "@/components/AuthComponents/Candidates/FilterBlock/FilterBlock";
import {
  SortDirectionField,
  SortDirectionUS,
  SortField,
  SortMapping,
} from "@/components/AuthComponents/Candidates/types";
import DeleteCandidateFromVacancy from "@/components/BaseComponents/Popups/DeleteCandidateFromVacancy/Modal";
import ChangeStatusPopup from "@/components/BaseComponents/Popups/VacancyChangeStatus/Modal";
import { DICTIONARY } from "@/constants/dictionary";
import { ROUTE_CANDIDATE } from "@/constants/routes";
import {
  candidateCustomApi,
  useCandidatesListQuery,
  useLazyCandidatesListQuery,
} from "@/core/api/candidate/candidate";
import { useVacationSendResumeMutation } from "@/core/api/vacancy/vacancy";
import { useUserStore } from "@/core/store/UserDataStore";
import { DocIcon } from "@/services/docicon.service";
import { snackbarFail, snackbarSuccess } from "@/services/snackbar.service";
import { camelCaseToUnderscore } from "@/services/string.service";
import {
  Button,
  Checkbox,
  Pagination,
  Popup,
  Tooltip,
  useSnackbars,
} from "@aurora/components";
import {
  GlyphBin,
  GlyphForbidden,
  GlyphSwap,
  SmallFall,
  SmallGrow,
} from "@aurora/icons";
import cx from "classnames";
import React, { FC, useEffect, useState } from "react";
import ReactDOM from "react-dom";

interface Props {
  vacancy?: any;
  refreshList?: boolean;
}

const getDefaultSelecteFilter = () => {
  return {
    changeStatus: [],
    sendResume: [],
  };
};

const initSortDirection: SortDirectionField = {
  fullName: undefined,
  resumeUploadDate: undefined,
};

const sortMapping: SortMapping = {
  fullName: "FULL_NAME",
  resumeUploadDate: "RESUME_UPLOAD_DATE",
};

const VacancyCardCandidates: FC<Props> = ({ refreshList, vacancy }: any) => {
  const { isManagerOrWatcher } = useUserStore();
  const FilterBlockID = document.getElementById("RightSideBarFilterBlock");
  const { snackbarInfo } = useSnackbars();
  const [isResendResumeBtnDisabled, changeResendResumeDisabledBtn] =
    useState(true);
  const [isMassStatusesBtnDisabled, changeMassStatusesDisabledBtn] =
    useState(true);
  const [loadingFilter, changeIsLoadingFilter] = useState(false);
  const [isLoadingModal, changeIsLoadingModal] = useState(false);
  const [selectedItemsFilter, changeSelectedItemsFilter]: any = useState(
    getDefaultSelecteFilter(),
  );
  const [statusCandidateId, setStatusCandidateId] = useState<string | null>();
  const [isModalStatusEditOpen, setIsModalStatusEditOpen] = useState(false);
  const [isModalMassStatusEditOpen, setIsMassModalStatusEditOpen] =
    useState(false);
  const [selectedItems, setSelectedItems]: any = useState({});
  const [selectedItemsRessend, setSelectedItemsRessend]: any = useState([]);
  const [isSelectAll, changeSelectAll]: any = useState(false);
  const [btnDisabledResend, changeBtnDisabledResend]: any = useState(true);
  const [documentLoaded, setDocumentLoaded] = useState<string | null>(null);
  const [showDocumentView, setShowDocumentView] = useState<boolean>(false);
  const [pageCount, setPageCount] = useState(0);
  const [currentCandidateId, setCurrentCandidateId] = useState<string>("");

  const [showPopupReplyMessage, changeShowPopupReplyMessage]: any =
    useState(false);
  const [isModalDeleteCandidateOpen, setIsModalDeleteCandidateOpen] =
    useState(false);

  const [sortDirection, setSortDirection] =
    useState<SortDirectionField>(initSortDirection);
  const [queryParamsCandidate, updateQueryParamsCandidate] = useState<any>({
    createPeriodEnd: "",
    createPeriodStart: "",
    pageNum: 1,
    pageSize: 10,
    personIds: "",
    ts: new Date().getTime(),
    vacancyIds: vacancy.id,
  });

  const { data: candidatesData, isLoading: candidatesDataIsLoading } =
    useCandidatesListQuery(queryParamsCandidate);

  const [sendResume] = useVacationSendResumeMutation();
  const [loadCandidatesData] = useLazyCandidatesListQuery();

  useEffect(() => {
    if (candidatesDataIsLoading) return;
    isAllItemsSelected();
    if (candidatesData)
      setPageCount(
        Math.ceil(candidatesData.total / queryParamsCandidate.pageSize),
      );
    else setPageCount(0);
  }, [candidatesDataIsLoading, selectedItems]);

  useEffect(() => {
    changeBtnDisabledResend(true);
    selectedItemsRessend.map((item: any) => {
      if (selectedItems[item.id]) {
        changeBtnDisabledResend(false);
      }
    });
  }, [selectedItems, selectedItemsRessend]);

  useEffect(() => {
    if (!candidatesDataIsLoading) {
      const sortFieldValue = Object.keys(sortDirection).find(
        v => sortDirection[v as keyof SortDirectionField] !== undefined,
      );
      const sortFieldValueUS = sortMapping[sortFieldValue as keyof SortMapping];
      const sortOrderValue = camelCaseToUnderscore(
        sortDirection[sortFieldValue as keyof SortDirectionField],
      ) as SortDirectionUS;
      const newQueryParams = {
        sortField: sortFieldValueUS,
        sortOrder: sortOrderValue,
      };
      updateQueryParamsCandidate((prev: any) => ({
        ...prev,
        ...newQueryParams,
      }));
    }
  }, [sortDirection]);

  function clickOnCloseReplyMessage() {
    changeShowPopupReplyMessage(false);
    clearAllChecked();
    setSelectedItemsRessend([]);
    changeResendResumeDisabledBtn(false);
    changeIsLoadingFilter(false);
  }

  function clearAllChecked() {
    setSelectedItems({});

    changeSelectedItemsFilter(getDefaultSelecteFilter());
    changeResendResumeDisabledBtn(true);
    changeMassStatusesDisabledBtn(true);
  }

  function viewFile(candidateId: string) {
    setCurrentCandidateId(candidateId);
    candidateCustomApi.downloadResume(candidateId).then(file => {
      if (!file.data) return;
      setDocumentLoaded(URL.createObjectURL(file.data));
    });
  }

  function openFileInNewTab(candidateId: string) {
    const link = document.createElement("a");
    candidateCustomApi.downloadResume(candidateId).then(file => {
      if (!file.data) return;
      link.href = URL.createObjectURL(file.data);
      link.download = file.name || `resume_${candidateId}_download`; // имя файла для скачивания (можно задать любое)
      link.dispatchEvent(new MouseEvent("click"));
    });
  }

  function isAllItemsSelected() {
    let isSelectedAll = true;

    candidatesData?.items.forEach((candidate: any) => {
      if (!selectedItems[candidate.id]) isSelectedAll = false;
    });

    changeSelectAll(isSelectedAll);
  }

  async function sendResumeFn() {
    const result: any = await sendResume({
      personIds: getActiveManagers("sendResume"),
      vacancyId: vacancy.id,
    });
    changeIsLoadingFilter(false);
    changeIsLoadingModal(false);

    if (result.error) {
      const fail: any = snackbarFail(DICTIONARY.FAIL_RESUME_SEND);
      snackbarInfo?.show(fail);
      changeResendResumeDisabledBtn(false);
    } else {
      const success: any = snackbarSuccess(DICTIONARY.SUCCESS_RESUME_SEND);
      clearAllChecked();
      snackbarInfo?.show(success);
    }

    changeShowPopupReplyMessage(false);
  }

  function getActiveManagers(type: string | undefined = "") {
    if (type && selectedItemsFilter[type]) {
      return selectedItemsFilter[type];
    }

    return Object.keys(selectedItems).filter(managerId => {
      return selectedItems[managerId];
    });
  }

  function selectedHandle(item: any, isSelected: boolean) {
    changeSelectedItemsFilter((old: any) => {
      const nValues = Object.assign({}, old);

      if (isSelected) {
        if (item.resumeUploaded) {
          nValues.sendResume.push(item.id);
        }
        nValues.changeStatus.push(item.id);
      }
      if (!isSelected) {
        if (item.resumeUploaded) {
          nValues.sendResume = nValues.sendResume.filter(
            (personId: string) => personId !== item.id,
          );
        }
        nValues.changeStatus = nValues.changeStatus.filter(
          (personId: string) => personId !== item.id,
        );
      }

      changeResendResumeDisabledBtn(nValues.sendResume.length === 0);
      changeMassStatusesDisabledBtn(nValues.changeStatus.length === 0);

      return nValues;
    });
  }
  const header = [
    { element: "", item: "marker" },
    {
      element: (
        <Checkbox
          checked={isSelectAll}
          onChange={() => {
            setSelectedItems((oldValues: any) => {
              const isSelected = !isSelectAll;
              const nValues = Object.assign({}, oldValues);
              candidatesData?.items.forEach((item: any) => {
                if (nValues[item.id] === isSelected) return;
                nValues[item.id] = isSelected;
                selectedHandle(item, isSelected);
              });
              return nValues;
            });
          }}
        />
      ),
      item: "checkboxAction",
    },
    {
      element: (
        <div>
          ФИО <br /> кандидата
        </div>
      ),
      item: "fullName",
    },
    {
      element: (
        <div>
          Контактные
          <br />
          данные
        </div>
      ),
      item: "contacts",
    },
    {
      element: (
        <div>
          Дата
          <br />
          резюме
        </div>
      ),
      item: "resumeUploadDate",
    },
    { element: <div>Файл</div>, item: "file" },
    {
      element: (
        <div>
          Текущий
          <br />
          статус
        </div>
      ),
      item: "status",
    },
    { element: "", item: "actionBtn" },
  ];
  function refreshCandidateData() {
    updateQueryParamsCandidate((prev: any) => ({
      ...prev,
      ts: new Date().getTime(),
    }));
  }

  useEffect(() => {
    if (refreshList) {
      refreshCandidateData();
    }
  }, [refreshList]);

  const tableHead = header.map((item: any) => {
    const sortIcon = (
      <div
        className={cx(
          style.CandidatesTable__icon,
          style.CandidatesTable__icon__align_left,
        )}
      >
        {sortDirection[item.item as SortField] === "asc" && (
          <SmallFall data-testid="sort-down" />
        )}
        {sortDirection[item.item as SortField] === "desc" && (
          <SmallGrow data-testid="sort-up" />
        )}
      </div>
    );
    function onSort(item: SortField) {
      if (!sortDirection[item])
        setSortDirection({ ...initSortDirection, [item]: "asc" });
      if (sortDirection[item] === "asc")
        setSortDirection({ ...initSortDirection, [item]: "desc" });
      if (sortDirection[item] === "desc")
        setSortDirection({ ...initSortDirection });
    }

    return (
      <th
        key={item.item}
        className={cx(
          item.item in sortDirection && style.CandidatesTable__point,
        )}
        onClick={() => {
          if (item.item in sortDirection) onSort(item.item);
        }}
      >
        {item.item in sortDirection && sortIcon}
        {item.element}
      </th>
    );
  });

  return (
    <>
      <div className={style.CandidatesListContainer}>
        <FilterBlock
          updateCandidateData={updateQueryParamsCandidate}
          vacancyId={vacancy.id}
        />
        {candidatesData && candidatesData?.total <= 0 ? (
          <NoData />
        ) : (
          <table className={style.CandidatesTable}>
            <colgroup>
              <col width={"32px"} />
              <col width={"32px"} />
              <col width={"60%"} />
              <col width={"40%"} />
              <col width={"100px"} />
              <col width={"70px"} />
              <col width={"160px"} />
              <col width={"140px"} />
            </colgroup>
            <thead>
              <tr>{tableHead.map((element: any) => element)}</tr>
            </thead>
            <tbody>
              {candidatesDataIsLoading ? (
                <SkeletonTable rows={10} />
              ) : (
                candidatesData?.items.map((item: any) => {
                  return (
                    <tr
                      key={item.id}
                      onClick={() => {
                        window.open(
                          `${ROUTE_CANDIDATE}/?candidateId=${item.id}`,
                          "_blank",
                          "noreferrer",
                        );
                      }}
                    >
                      <td>
                        {item.inBlackList && (
                          <Tooltip
                            content={"Кандидат в черном списке"}
                            placement="topLeft"
                            triggerOn="hover"
                          >
                            <GlyphForbidden className="text-destructive" />
                          </Tooltip>
                        )}
                      </td>
                      <td
                        onClick={(event: any) => {
                          event.preventDefault();
                          event.stopPropagation();
                          setSelectedItems((old: any) => {
                            const isSelected = !selectedItems[item.id];
                            const nValues = {
                              ...old,
                              [item.id]: !selectedItems[item.id],
                            };

                            selectedHandle(item, isSelected);
                            return nValues;
                          });
                        }}
                      >
                        <Checkbox checked={selectedItems[item.id]} />
                      </td>
                      <td title={item.fullName}>{item.fullName}</td>
                      <td>
                        <div className="pb-2">{item.phone || null}</div>
                        <div className="rem-09">{item.email || null}</div>
                      </td>
                      <td>
                        {item.resumeUploaded
                          ? new Date(item.resumeUploadDate).toLocaleDateString()
                          : "-"}
                      </td>
                      <td align={"center"}>
                        <>
                          {item.resumeUploaded ? (
                            <div className={style.IconViewers}>
                              <a
                                className={"link"}
                                onClick={(e?: React.MouseEvent) => {
                                  e?.stopPropagation();
                                  if (
                                    item.resumeFileName
                                      .toLowerCase()
                                      .endsWith(".pdf")
                                  ) {
                                    viewFile(item.id);
                                  } else {
                                    openFileInNewTab(item.id);
                                  }
                                }}
                              >
                                <DocIcon fileName={item.resumeFileName} />
                              </a>
                            </div>
                          ) : (
                            <span>&nbsp;-</span>
                          )}
                        </>
                      </td>
                      <td className="truncate-cell">
                        {item.vacancies &&
                          item.vacancies
                            .filter(
                              (value: any) => value.vacancyId === vacancy.id,
                            )
                            .map((value: any, idx: number) => (
                              <CandidateBadge
                                key={idx}
                                badge={{
                                  stateCategoryCode:
                                    value.candidateStateCategoryCode,
                                  stateTitle: value.candidateStateTitle,
                                }}
                              />
                            ))}
                      </td>
                      <td className={"pr-4"}>
                        <Button
                          className={cx("mr-4", "text-black")}
                          iconLeft={<GlyphSwap />}
                          onClick={(e?: React.MouseEvent) => {
                            e?.stopPropagation();
                            setStatusCandidateId(item.id);
                            setIsModalStatusEditOpen(true);
                            return;
                          }}
                          variant="secondary"
                        ></Button>
                        {isManagerOrWatcher ? (
                          ""
                        ) : (
                          <Button
                            className={cx("text-black")}
                            iconLeft={<GlyphBin />}
                            onClick={(e?: React.MouseEvent) => {
                              e?.preventDefault();
                              e?.stopPropagation();
                              setStatusCandidateId(item.id);
                              setIsModalDeleteCandidateOpen(true);
                              setSelectedItems((old: any) => {
                                const nValues = {
                                  ...old,
                                };
                                delete nValues[item.id];
                                selectedHandle(item, false);
                                return nValues;
                              });
                            }}
                            variant="secondary"
                          ></Button>
                        )}
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        )}
      </div>
      {pageCount > 1 && (
        <Pagination
          className="pl-0 pagination"
          currentNumber={queryParamsCandidate.pageNum}
          onChange={function ka(page: any) {
            updateQueryParamsCandidate({
              ...queryParamsCandidate,
              pageNum: page,
            });
          }}
          total={pageCount}
        />
      )}
      {FilterBlockID &&
        ReactDOM.createPortal(
          <>
            <div className={style.MassOperationBlock}>
              <div className="mb-4">
                <Button
                  disabled={isResendResumeBtnDisabled}
                  loading={loadingFilter}
                  onClick={async () => {
                    changeResendResumeDisabledBtn(true);
                    changeIsLoadingFilter(true);
                    const personIds = getActiveManagers();

                    const getListManagers: any = await loadCandidatesData({
                      pageNum: 1,
                      pageSize: 999,
                      personIds,
                      vacancyIds: vacancy.id,
                    });

                    const ressendResume: any = [];
                    if (
                      getListManagers &&
                      getListManagers.data &&
                      getListManagers.data.items
                    ) {
                      getListManagers.data.items.forEach((manager: any) => {
                        let needAddManager = false;
                        manager.vacancies.forEach((vac: any) => {
                          if (vac.vacancyId === vacancy.id && vac.resumeSent) {
                            needAddManager = true;
                          }
                        });

                        if (needAddManager) ressendResume.push(manager);
                      });
                    }

                    if (ressendResume.length) {
                      changeShowPopupReplyMessage(true);
                      setSelectedItemsRessend(ressendResume);
                      changeIsLoadingFilter(false);
                    } else {
                      sendResumeFn();
                    }
                  }}
                >
                  Отправить резюме ({selectedItemsFilter.sendResume.length})
                </Button>
              </div>
              <div className="mb-2">
                <Button
                  disabled={isMassStatusesBtnDisabled}
                  loading={false}
                  onClick={async () => {
                    changeMassStatusesDisabledBtn(false);
                    setIsMassModalStatusEditOpen(true);
                  }}
                >
                  Сменить статус ({selectedItemsFilter.changeStatus.length})
                </Button>
              </div>
            </div>
          </>,
          FilterBlockID,
        )}
      {showPopupReplyMessage && (
        <Popup
          classNameContent={cx(style.modal, "p-16")}
          classNameWrapper="p-0"
          onClickCloseCross={clickOnCloseReplyMessage}
          onClickOutside={clickOnCloseReplyMessage}
        >
          <div>
            <div className="text-center mb-4">
              Резюме уже направлялись нанимающему менеджеру. <br /> Выберите
              резюме для повторной отправки.
            </div>
            <div className={`mb-8 ${style.CandidateListAfterSelected}`}>
              {selectedItemsRessend.map((item: any, key: number) => {
                return (
                  <div
                    key={key}
                    className={"d-flex mb-8"}
                    onClick={() => {
                      const isSelected = !selectedItems[item.id];
                      setSelectedItems((old: any) => {
                        const nValues = {
                          ...old,
                          [item.id]: isSelected,
                        };
                        selectedHandle(item, isSelected);

                        return nValues;
                      });
                    }}
                  >
                    <div className={"mr-4"}>
                      <Checkbox
                        checked={selectedItems[item.id]}
                        onChange={() => {
                          const isSelected = selectedItems[item.id];
                          setSelectedItems((old: any) => {
                            const nValues = {
                              ...old,
                              [item.id]: isSelected,
                            };
                            selectedHandle(item, isSelected);

                            return nValues;
                          });
                        }}
                      />
                    </div>
                    <div>{item.fullName}</div>
                  </div>
                );
              })}
            </div>

            <div>
              <div className={`${style.btnGroup}`}>
                <Button
                  className="mr-4"
                  disabled={isLoadingModal || btnDisabledResend}
                  loading={isLoadingModal}
                  onClick={() => {
                    changeIsLoadingModal(true);
                    sendResumeFn();
                  }}
                >
                  Отправить
                </Button>
                <Button
                  disabled={isLoadingModal}
                  onClick={() => clickOnCloseReplyMessage()}
                  variant="secondary"
                >
                  Отменить
                </Button>
              </div>
            </div>
          </div>
        </Popup>
      )}
      {isModalMassStatusEditOpen && (
        <ChangeStatusPopup
          candidate={selectedItemsFilter.changeStatus}
          clickOnClose={(needUpdateList = false) => {
            setIsMassModalStatusEditOpen(false);
            clearAllChecked();
            if (needUpdateList) {
              updateQueryParamsCandidate((prev: any) => ({
                ...prev,
                ts: new Date().getTime(),
              }));
            }
          }}
          vacancy={{ id: vacancy.id }}
        />
      )}
      {isModalStatusEditOpen && (
        <ChangeStatusPopup
          candidate={{ id: statusCandidateId }}
          clickOnClose={(needUpdateList = false) => {
            setIsModalStatusEditOpen(false);
            if (needUpdateList) {
              refreshCandidateData();
            }
          }}
          vacancy={{ id: vacancy.id }}
        />
      )}
      {isModalDeleteCandidateOpen && (
        <DeleteCandidateFromVacancy
          candidateId={statusCandidateId}
          clickOnClose={(needUpdateList = false) => {
            setIsModalDeleteCandidateOpen(false);
            if (needUpdateList) {
              refreshCandidateData();
            }
          }}
          vacancy={vacancy}
        />
      )}
      {!showDocumentView &&
        ReactDOM.createPortal(
          <>
            <RightSidebar
              onClose={() => {
                setDocumentLoaded(null);
              }}
              show={!!documentLoaded}
            >
              {!!documentLoaded && (
                <PdfViewer
                  candidateId={currentCandidateId}
                  url={documentLoaded}
                />
              )}
            </RightSidebar>
          </>,
          document.body,
        )}
    </>
  );
};

export default VacancyCardCandidates;
